import { ChangeEvent, ReactNode } from 'react'
import { Theme } from '@emotion/react'
import styled from '@emotion/styled'
import { FusionColor } from '../../../theme/FusionStyle'

type L1SelectControlProps = {
	padding?: string,
	background?: FusionColor,
	color?: FusionColor,
	borderColor?: FusionColor,
	expand?: boolean,
	disabled?: boolean,
} & {
	theme: Theme
}

const L1SelectControl = styled.select(({theme, expand, color, borderColor, disabled, padding = theme.spacing(1.5, 3), background}: L1SelectControlProps) => ({
	borderRadius: theme.spacing(1),
	padding: padding,
	backgroundColor: background ? theme.colors[background] : theme.colors.second,
	color: color ? theme.colors[color] : 'inherit',
	borderColor: borderColor ? theme.colors[borderColor] : theme.colors.lines,
	fontFamily: 'inherit',
	fontSize: 'inherit',
	width: expand ? '100%' : undefined
}))

export interface L1SelectProps {
	className?: string,
	value?: string|null,
	nullOption?: boolean,
	padding?: string,
	background?: FusionColor,
	onChange?: (e: ChangeEvent<HTMLSelectElement>) => void,
	children?: ReactNode,
	placeholder?: string
	expand?: boolean
	disabled?: boolean,
	color?: FusionColor,
	borderColor?: FusionColor
}

const L1Select = ({className, value, padding, expand, disabled, color, borderColor, background, nullOption = true, onChange, children, placeholder}: L1SelectProps) => {
	// this prevents console nastygrams about the type of value
	// and also causes nullOption to be selected more predictably
	if(value === null || value === undefined) {
		value = ''
	}
	return (
		<L1SelectControl
			color={color}
			borderColor={borderColor}
			className={className}
			onChange={onChange}
			value={value}
			padding={padding}
			background={background}
			expand={expand}
			disabled={disabled}
		>
			{/* default null option to avoid making first option the value
			if nothing has been selected by the user already */}
			{nullOption ? <option value=''>{placeholder}</option> : null}
			{children}
		</L1SelectControl>
	)
}

export default L1Select
